import { IconButton } from "@/components/Buttons/IconButton";
import { ItemSeperatorList } from "@/components/List";
import { Pressable } from "@/components/Theme/Pressable";
import { Row } from "@/components/Theme/Row";
import { ThemeText } from "@/components/Theme/ThemeText";
import { ThemeView } from "@/components/Theme/ThemeView";
import { View } from "@/components/Theme/View";
import { useCurrentUrl } from "@/hooks/useCurrentUrl";
import { useScrollTo } from '@nandorojo/anchor';
import { Link } from "expo-router";
import { useCallback, useMemo } from "react";

const HashLink = ({ children, href, ...rest }) => {
    const { rawUrlPath } = useCurrentUrl();
    const { scrollTo } = useScrollTo();

    const onPress = () => {
        const targetId = href.slice(1);
        scrollTo(targetId, { animated: true, offset: -75 });
    }

    return (
        <Link push asChild href={`${rawUrlPath}${href}`}>
            <Pressable onPress={onPress}>
                <ThemeText {...rest}>
                    {children}
                </ThemeText>
            </Pressable>
        </Link>
    );
}

export function inhaltsverzeichnis(node, children, parent, styles, colorScheme) {
    const entries = JSON.parse(node.attributes?.entries ?? "[]");

    const isMultiLevel = entries?.some(e => e.level > 1);

    const key = useMemo(() => entries?.map(e => e.link).join(',') ?? 'empty', [entries]);

    const renderItem = useCallback((entry) => {

        const variant = isMultiLevel && entry.level === 1 ? 'pbold' : 'p';

        return (
            <Row gap={15} ml={(entry.level-1) * 15} alignItems={'center'}>
                <IconButton icon={'chevron-right'} size={15} />
                <View flex={1}>
                    <HashLink href={entry.link} variant={variant}>
                        {entry.number}. {entry.text}
                    </HashLink>
                </View>
            </Row>
        )
    }, [isMultiLevel]);

    return (
        <ThemeView p={25} light={'muted.100'} dark={'muted.800'} mb={35}>
            <ThemeText variant={'xs'} id={'Inhaltsverzeichnis'} />
            
            <View h={35} />

            <ItemSeperatorList
                key={key} 
                items={entries}
                gap={10}
                renderItem={renderItem}
            />
        </ThemeView>
    );
}